import Drawer from "@/components/drawer";
const mixin = {
	components: { Drawer },
	data() {
		return {
			open: false,
			hasConfirm: false
		}
	},
	methods: {
		changeOpen() {
			this.open = !this.open
		},
		closeDrawer() {
			if (this.hasConfirm) {
				this.$confirm("确认关闭？")
					.then(() => {
						this.changeOpen()
					})
					.catch();
			} else {
				this.changeOpen()
			}

		}
	},
}

export default mixin